import React, { useState } from 'react';
import produce from 'immer';
import { IToast } from '@/typings/global';
import Toast from './Toast';

interface IProps {
    limit: number;
}
function ToastContainer({ limit }: IProps): JSX.Element {
    const [toasts, setToast] = useState([]);
    const destroy = (id: string) => {
        const newToasts = toasts.filter((item) => item.id !== id);
        setToast(newToasts);
    };
    const addToast = (dat: IToast) => {
        let toast = null;
        setToast(
            produce(toasts, (draft) => {
                if (toasts.length === limit) {
                    draft[0].content = dat.content;
                    draft[0].type = dat.type;
                    draft[0].duration = dat.duration;
                    draft[0].icon = dat.icon;
                    toast = {
                        id: draft[0].id,
                        type: dat.type,
                        content: dat.content,
                        duration: dat.duration,
                        icon: dat.icon
                    };
                } else {
                    draft.push({
                        id: `toast${toasts.length + 1}`,
                        type: dat.type,
                        content: dat.content,
                        duration: dat.duration,
                        icon: dat.icon
                    });
                    toast = {
                        id: `toast${toasts.length + 1}`,
                        type: dat.type,
                        content: dat.content,
                        duration: dat.duration,
                        icon: dat.icon
                    };
                }
            })
        );
        return toast;
    };
    window.IM.Toast = {
        info: (dat) => addToast({ type: 'info', ...dat }),
        warning: (dat) => addToast({ type: 'warning', ...dat }),
        error: (dat) => addToast({ type: 'error', ...dat }),
        success: (dat) => addToast({ type: 'success', ...dat }),
        destroy
    };
    return (
        toasts.length > 0 && (
            <div className="toast-wrapper">
                {toasts.map((item, ind) => (
                    <Toast
                        key={`toast${ind + 1}`}
                        id={item.id}
                        type={item.type}
                        content={item.content}
                        duration={item.duration}
                        icon={item.icon}
                        destroy={destroy}
                    />
                ))}
            </div>
        )
    );
}

export default ToastContainer;
